import { render, staticRenderFns } from "./SpeciesSettings.vue?vue&type=template&id=2fa2fe6e&"
import script from "./SpeciesSettings.vue?vue&type=script&lang=js&"
export * from "./SpeciesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports